import React, { Fragment, memo, useState, useEffect } from 'react';
import config from 'Config';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { AbTasty } from './AbTasty';
import { ContentSquare } from './ContentSquare';
import { Hosting } from './Hosting';
import { Udesk } from './Udesk';
import { Cedexis } from './Cedexis';
import { Sentry } from './Sentry';
const DELAY_LOAD = config.get('thirdParty.delayLoad') ?? false;
const DELAY_TIMER = Number(config.get('thirdParty.timer') ?? 5000);
const LOAD_OPTIONS = {
  once: true,
  passive: true,
} as AddEventListenerOptions;
export const ThirdPartyScripts = memo<{}>(() => {
  const { isAppMounted } = useResponsive();
  const [delaying, setDelaying] = useState(DELAY_LOAD);
  useEffect(() => {
    if (!DELAY_LOAD || typeof window === 'undefined') {
      return;
    }

    const timeoutHandler = () => {
      setDelaying(false);
    };

    let timeout = null;

    const loadHandler = () => {
      timeout = setTimeout(timeoutHandler, DELAY_TIMER);
    };

    window.addEventListener('load', loadHandler, LOAD_OPTIONS as boolean | AddEventListenerOptions);
    return () => {
      window.removeEventListener(
        'load',
        loadHandler,
        LOAD_OPTIONS as boolean | AddEventListenerOptions,
      );
      clearTimeout(timeout);
    };
  }, []);

  // Third-party inline scripts must not SSR: server/client config can differ (APP_VERSION, etc.)
  if (!isAppMounted || delaying) {
    return null;
  }

  return (
    <Fragment>
      <Udesk />
      <ContentSquare />
      <Hosting />
      <AbTasty />
      <Cedexis />
      <Sentry />
    </Fragment>
  );
});
